<template>
    <div>
        <div id="serial_block_wrapper">
            <div id="serial_tab">
                <div class="serial-tab"
                    :class="{'active': serialType == 'QR_CODE'}"
                    @click="changeTab('QR_CODE')">
                    <div class="serial-lbl">{{lbl.serial.qr_code}}</div>
                </div>
                <div class="serial-tab"
                    :class="{'active': serialType == 'CODE_128'}"
                    @click="changeTab('CODE_128')">
                    <div class="serial-lbl">{{lbl.serial.barcode}}</div>
                </div>
                <div class="serial-tab"
                    :class="{'active': serialType == 'CODE'}"
                    @click="changeTab('CODE')">
                    <div class="serial-lbl">{{lbl.serial.code}}</div>
                </div>
            </div>
            <div id="serial_code"
                v-if="isShowCode && isLoaded">
                <div id="show_code_lbl">
                    {{lbl.serial.show_code_at_shop}}
                </div>
                <div id="code_wrapper">
                    <div class="serial-code"
                        v-show="serialType == 'QR_CODE'">
                        <VueQrcode
                            id="qrcode"
                            :value="serial"
                            :options="qrcodeConfig" />
                    </div>
                    <div class="serial-code"
                        v-show="serialType == 'CODE_128'">
                        <VueBarcode
                            id="barcode"
                            :value="serial"
                            :options="barcodeConfig" />
                    </div>
                    <div id="code_wrapper"
                        class="serial-code"
                        v-show="serialType == 'CODE'">
                        <p id="code"
                            :class="{'long-code': serial.length > 12, 'serial-expire' : serial == 'XXXXXXX'}">
                            {{serial}}
                        </p>
                        <div id="copy_code_btn"
                            class="btn-wrapper">
                            <div class="btn-txt"
                                v-clipboard:copy="serial"
                                v-clipboard:success="onCopyCode"
                                v-clipboard:error="onErrorCode">{{lbl.serial.copy_code}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="serial_privilege_message"
                v-if="!isShowCode && isLoaded">
                {{privilegeMessage}}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//plugin
import VueBarcode from '@chenfengyuan/vue-barcode'; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import VueQrcode from '@chenfengyuan/vue-qrcode'; // https://github.com/fengyuanchen/vue-qrcode

import VueClipboard from 'vue-clipboard2'
export default {
    name: 'Serial',
    components: {
        VueBarcode,
        VueQrcode
    },
    props: {
        controller: Object,

        lbl: Object,
        serialModel: Object
    },
    data: function () {
        return {
            isExpired: false,
            isLoaded: false,
            isShowCode: true,
            isTabLock: false,
            privilegeMsg: '',
            serial: '',
            serialType: '',

            barcodeConfig: {
                height: 100,
                displayValue: false,
                lineColor: '#000000'
            },
            qrcodeConfig: {
                width: 160,
                margin: 0,
            },
        };
    },
    created: function () {
        //initial copy plugin
        VueClipboard.config.autoSetContainer = true;
        Vue.use(VueClipboard);

        this.initial();
    },
    mounted: function () {
        this.controller.onSerialExpire(this.serialExpired);
    },
    methods: {
        //event
        changeTab: function (type) {
            if (this.isTabLock) return;

            this.serialType = type;
        },
        //initial
        initial: function () {
            if (!this.serialModel.serial) return;

            this.isExpired = false;
            this.serial = this.serialModel.serial;
            switch (this.serialModel.barcode) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    break;
                case 'QR_CODE':
                    this.serialType = 'QR_CODE';
                    break;
                default:
                    this.serialType = 'CODE';
                    break;
            }

            if (this.serialModel.barcode
                && this.serialModel.barcode.toLowerCase() == 'none'
                && this.serialModel.privilegeMessage)
                this.isShowCode = false;

            this.initialPrivilegeMessage();
            this.$nextTick(() => {
                this.isLoaded = true;
            });
        },
        initialPrivilegeMessage: function () {
            if (this.serialModel.privilegeMessage) {
                if (this.serialModel.privilegeMessageFormat) {
                    var privilegeMessageFormat = this.serialModel.privilegeMessageFormat.toLowerCase();
                    switch (privilegeMessageFormat) {
                        case 'link':
                            //reserve for landing
                            this.privilegeMsg = this.lbl.serial.show_code_at_shop;
                            break;
                        case 'html':
                            this.privilegeMsg = this.serialModel.privilegeMessage;
                            break;
                    }
                } else {
                    this.privilegeMsg = this.serialModel.privilegeMessage;
                }
            } else {
                this.privilegeMsg = this.lbl.serial.show_code_at_shop;
            }
        },
        //copy to clipboard
        onCopyCode: function (e) {
            console.log('copied', e.text);
        },
        onErrorCode: function (e) {
            console.log('failed', e);
        },
        //bus
        serialExpired: function () {
            this.isLoaded = false;

            this.isExpired = true;
            this.isTabLock = true;
            this.serial = 'XXXXXXX';
            this.serialType = 'CODE';

            //reload component
            this.$nextTick(() => {
                this.isLoaded = true;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
#serial_block_wrapper {
    #serial_tab {
        .serial-tab {
            position: relative;
            display: inline-block;
            width: calc(100% / 3);
            //font
            font-size: 0;
            white-space: normal;

            &:nth-child(2) {
                margin-left: -1px;
                margin-right: -1px;
            }

            .serial-lbl {
                position: relative;
                display: block;
                padding: 8px 0;
                //font
                color: rgba(black, 0.5);
                font-size: 1.15rem;
                text-align: center;
                line-height: 1.15;
                cursor: pointer;
            }

            &.active {
                border-bottom: 2px solid black;

                .serial-lbl {
                    color: black;
                }
            }
        }
    }

    #serial_code {
        padding: 20px 10px 0;

        #show_code_lbl {
            //font
            font-size: 1.45rem;
            font-weight: normal;
            text-align: center;
            line-height: 1;
        }

        .serial-code {
            @extend %display-flex;
            position: relative;
            height: 160px;
            margin: {
                top: 25px;
                bottom: 25px;
            }

            #barcode {
                width: fit-content;
                flex: 0 0 fit-content;
                margin: auto;
            }

            #qrcode {
                width: 160px;
                flex: 0 0 160px;
                margin: {
                    left: auto;
                    right: auto;
                }
            }

            &#code_wrapper {
                margin: {
                    left: auto;
                    right: auto;
                };

                #code {
                    width: 100%;
                    margin: {
                        top: auto;
                        bottom: 0;
                    }
                    //font
                    font-size: 4.5rem;
                    text-align: center;
                    line-height: 1;
                }

                #copy_code_btn {
                    min-height: 25px;
                    height: 25px;
                    margin: {
                        left: auto;
                        right: auto;
                        bottom: auto;
                    }

                    .btn-txt {
                        margin: 0;
                        padding: 0;
                        color: #d31145;
                        font-size: 1.1rem;
                    }
                }
            }
        }
    }

}
</style>

